var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.62602 5.48609C6.31124 5.1713 5.80087 5.1713 5.48609 5.48609C5.1713 5.80087 5.1713 6.31124 5.48609 6.62602L10.8601 12L5.48609 17.374C5.1713 17.6888 5.1713 18.1991 5.48609 18.5139C5.80087 18.8287 6.31124 18.8287 6.62602 18.5139L12 13.1399L17.374 18.5139C17.6888 18.8287 18.1991 18.8287 18.5139 18.5139C18.8287 18.1991 18.8287 17.6888 18.5139 17.374L13.1399 12L18.5139 6.62602C18.8287 6.31124 18.8287 5.80087 18.5139 5.48609C18.1991 5.1713 17.6888 5.1713 17.374 5.48609L12 10.8601L6.62602 5.48609Z",
    fill: "#1752AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueX);
export default __webpack_public_path__ + "static/media/BlueX.624ca9cc9c6cc0110c0bd96c7486c9d8.svg";
export { ForwardRef as ReactComponent };